// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 417 ? "setting" : chunkId) + "." + {"0":"6e6fda44","20":"5133adaa","112":"600ade4e","320":"c59dc14c","417":"c6d3890e","959":"d0b4ee4f"}[chunkId] + ".js";
};